import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { CircularProgress, TextField, Button } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import PersonOutlined from "@material-ui/icons/PersonOutlined";
import LockOutlined from "@material-ui/icons/LockOutlined";
import instance from "../../store/actions/instance";
import { setUser } from "../../store/actions/auth";
import { Redirect } from "react-router";
import ActionButton from "../ActionButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppleAuth from "./AppleAuth";
import GoogleAuth from "./GoogleAuth";
import PhoneAuth from "./PhoneAuth";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
class index extends Component {
  state = {
    mode: !this.props.email ? 0 : this.props.history.location?.state?.mode || 1,
    email: this.props.email,
    password: "",
    errors: {},
    errorText: "",
    showPassword: false,
    verify: false,
    code: "",
    optInMarketing: false,
    contactChannel: "Email",
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  submit = async () => {
    const { mode, email, password } = this.state;
    let errors = { email: false, password: false };
    if (
      !email.trim() ||
      !this.validateEmail(email.trim()) ||
      !password.trim() ||
      (password.trim().length < 8 && mode === 0)
    ) {
      if (!email.trim()) errors.email = true;
      if (!password.trim()) errors.password = true;
      if (email.trim() && !this.validateEmail(email.trim()))
        errors.email = this.t("Invalid email address");
      if (password.trim() && password.trim().length < 8 && mode === 0)
        errors.password = this.t("Minimum length is 8 characters");
      this.setState({ errors: errors });
      return;
    }
    this.setState({ loading: true, errorText: "" });
    try {
      const res = await instance.post("/email-auth/", this.state);
      if (!res.data.success) {
        if (res.data.errors) this.setState({ errors: res.data.errors });
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (res.data.verify) this.setState({ verify: true });
        else if (!this.props.auth.user) {
          this.props.setUser(res.data.token, this.props.history);
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };

  verify = async () => {
    const { code } = this.state;

    let errors = { code: false };
    if (!code.trim()) {
      errors.code = this.t("Please enter verification code");
    } else if (code.length !== 6) {
      errors.code = this.t("Invalid verification code");
    }
    if (errors.code) {
      this.setState({ errors: errors });
      return;
    }
    this.setState({ verifyLoading: true, errorText: "" });
    try {
      const res = await instance.post("/verify-email/", this.state);
      if (!res.data.success) {
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (!this.props.auth.user) {
          this.props.setUser(res.data.token, this.props.history);
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ verifyLoading: false });
  };

  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;

    const trans = {
      "Sign up": "التسجيل",
      "Log in": "تسجيل الدخول",
      Email: "الايميل",
      Password: "كلمة المرور",
      "Confirm password": "تأكيد كلمة المرور",
      "Already a user? LOGIN": "لديك حساب؟ اضغط لتسجيل الدخول",
      "Don't have an account? SIGN UP": "ليس لديك حساب؟ اضغط للتسجيل",
      "Invalid email address": "الايميل غير صحيح",
      "Minimum length is 8 characters": "الحد الأدنى 8 احرف",
      "The two passwords don't match": "لا يوجد تطابق بكلمتي المرور",
      "This email is already registered": "هذا الايميل مستخدم من قبل",
      "Invalid login credentials": "بيانات الدخول غير صحيحة. حاول مرة اخرى",
      "Forgot password?": "نسيت كلمة المرور؟",
      Register: "التسجيل",
      Login: "تسجيل الدخول",
      OR: "أو",
      "An email was sent to": "تم ارسال ايميل الى",
      "with a 6 digit verification code. Please enter it below":
        "مع رمز تحقق مكون من 6 رموز. قم بإدخاله ادناه",
      "Invalid verification code": "رمز تحقق خاطئ",
      "Please enter verification code": "الرجاء ادخال رمز التحقق",
      "Confirmation code": "رمز التحقق",
      Verify: "اتمام التحقق",
    };
    return trans[text] || text;
  };
  render() {
    const {
      language,
      auth,
      cart,
      cart_items,
      promo_items,
      customTexts,
      settings,
    } = this.props;
    const totalCartLength = cart_items.length + promo_items.length;
    if (this.props.auth.user) return <Redirect to="/" />;

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };

    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <div className="free-space-70-white"></div>
        <ProductHeader onBack={() => this.props.history.goBack()} />

        {!this.state.verify && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              columnGap: 7,
              padding: "0px 15px",
              //width: "calc(100% - 10px)",
              direction: language === "arabic" ? "rtl" : "ltr",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: 40,
                border: "1px solid #0099cc",
                color: this.state.mode === 1 ? "white" : "#0099cc",
                width: "100%",
                borderRadius: 5,
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                cursor: "pointer",
                background: this.state.mode === 1 ? "#0099cc" : "transparent",
              }}
              onClick={() => this.setState({ mode: 1, errorText: "" })}
            >
              {this.t("Login")}
            </div>
            <div
              style={{
                height: 40,
                border: "1px solid #0099cc",
                color: this.state.mode === 0 ? "white" : "#0099cc",
                width: "100%",
                borderRadius: 5,
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                cursor: "pointer",
                background: this.state.mode === 0 ? "#0099cc" : "transparent",
              }}
              onClick={() => this.setState({ mode: 0, errorText: "" })}
            >
              {this.t("Register")}
            </div>
          </div>
        )}
        <div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: 20,
              marginTop: 30,
              padding: "0px 15px",
              color: "#666",
            }}
            className={language === "arabic" ? "text-right" : "text-left"}
          >
            {this.state.mode === 0 ? this.t("Register") : this.t("Login")}{" "}
            {!!this.state.errorText && (
              <span style={{ color: "red", fontWeight: "bold", fontSize: 14 }}>
                - {this.state.errorText}
              </span>
            )}
          </p>

          {!this.state.verify ? (
            <div style={{ padding: "0px 15px" }}>
              <TextField
                fullWidth
                label={this.t("Email")}
                required
                //   InputProps={{
                //     startAdornment: (
                //       <InputAdornment position="start">
                //         <PersonOutlined />
                //       </InputAdornment>
                //     ),
                //   }}
                value={this.state.email.toLowerCase()}
                onChange={(e) =>
                  this.setState({
                    email: e.target.value,
                    errors: { ...this.state.errors, email: false },
                    errorText: "",
                  })
                }
                error={!!this.state.errors.email}
                helperText={
                  typeof this.state.errors.email === "string"
                    ? this.state.errors.email
                    : undefined
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language === "english" ? "ltr" : "rtl",
                  style: { textTransform: "lowercase" },
                }}
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
              />

              <TextField
                fullWidth
                label={this.t("Password")}
                className={"my-4"}
                required
                type={this.state.showPassword ? "text" : "password"}
                onChange={(e) =>
                  this.setState({
                    password: e.target.value,
                    errors: { ...this.state.errors, password: false },
                    errorText: "",
                  })
                }
                error={!!this.state.errors.password}
                helperText={
                  typeof this.state.errors.password === "string"
                    ? this.state.errors.password
                    : undefined
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.submit();
                  }
                }}
                InputProps={{
                  dir: language === "english" ? "ltr" : "rtl",
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                        edge="end"
                      >
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
              />
              {this.props.settings.enable_dot && this.state.mode === 0 && (
                <div style={{ marginTop: "15px", marginBottom: "20px" }}>
                  <Checkbox
                    checked={this.state.optInMarketing}
                    onChange={(e) =>
                      this.setState({
                        optInMarketing: e.target.checked,
                        contactChannel: "Email",
                      })
                    }
                    name="opt_in_marketing"
                    checkedIcon={
                      <CheckBoxIcon style={{ color: this.props.themeColor }} />
                    }
                  />
                  <span style={{ marginLeft: "8px" }}>
                    {language === "english"
                      ? "By checking this box, you agree to receive marketing materials"
                      : "بتحديد هذا المربع ، فإنك توافق على استلام المواد التسويقية"}
                  </span>

                  {this.state.optInMarketing && (
                    <div style={{ marginTop: "25px" }}>
                      <p>
                        {language === "english"
                          ? "I want to receive offers by:"
                          : ":أرغب في تلقي العروض عن طريق"}
                      </p>
                      <RadioGroup
                        aria-label="contact-channel"
                        name="contactChannel"
                        value={this.state.contactChannel}
                        onChange={(e) =>
                          this.setState({ contactChannel: e.target.value })
                        }
                        style={{
                          display: "flex",
                          flexDirection: "row", // Align options horizontally
                          gap: "15px", // Add space between options
                          justifyContent: "center",
                        }}
                      >
                        <FormControlLabel
                          value="Email"
                          control={
                            <Radio
                              checkedIcon={
                                <RadioButtonCheckedIcon
                                  style={{ color: this.props.themeColor }}
                                />
                              }
                            />
                          }
                          label="Email"
                        />
                        <FormControlLabel
                          value="SMS"
                          control={
                            <Radio
                              checkedIcon={
                                <RadioButtonCheckedIcon
                                  style={{ color: this.props.themeColor }}
                                />
                              }
                            />
                          }
                          label="SMS"
                        />
                      </RadioGroup>
                    </div>
                  )}
                </div>
              )}

              {this.state.mode === 1 && (
                <div
                  style={{
                    textAlign: language === "arabic" ? "left" : "right",
                  }}
                >
                  <Button
                    variant="text"
                    onClick={() =>
                      this.props.history.push("/profile/forgot-password", {
                        email: this.state.email,
                      })
                    }
                    style={{ color: "#0099cc" }}
                  >
                    {this.t("Forgot password?")}
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div style={{ padding: "0px 15px" }}>
              <p style={{ direction: language === "arabic" ? "rtl" : "ltr" }}>
                {this.t("An email was sent to")}{" "}
                <span style={{ fontWeight: "bold" }}>{this.state.email}</span>{" "}
                {this.t(
                  "with a 6 digit verification code. Please enter it below"
                )}
              </p>{" "}
              <TextField
                fullWidth
                label={this.t("Confirmation code")}
                required
                value={this.state.code.toLowerCase()}
                onChange={(e) =>
                  this.setState({
                    code: e.target.value,
                    errors: {},
                    errorText: "",
                  })
                }
                error={!!this.state.errors.code}
                helperText={
                  typeof this.state.errors.code === "string"
                    ? this.state.errors.code
                    : undefined
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language === "english" ? "ltr" : "rtl",
                  style: { textTransform: "lowercase" },
                }}
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
              />
              <Button
                variant="contained"
                className="my-4"
                style={{
                  backgroundColor: "#0099cc",
                  color: "white",
                  width: 250,
                  height: 50,
                }}
                size="large"
                disableElevation
                onClick={() => this.verify()}
              >
                {!this.state.verifyLoading ? (
                  <span className="bold">{this.t("Verify")}</span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </Button>
            </div>
          )}
        </div>

        <p
          style={{
            color: "#999",
            marginTop: 40,
            fontSize: 18,
          }}
        >
          <span style={{ letterSpacing: -3, margin: "0px 10px" }}>
            --------------------
          </span>
          <span style={{ fontWeight: "bold" }}>{this.t("OR")}</span>
          <span style={{ letterSpacing: -3, margin: "0px 10px" }}>
            --------------------
          </span>
        </p>

        <h2
          classname="bold"
          style={{
            fontSize: 20,
            color: "#666666",
            textAlign: language === "arabic" ? "right" : "left",
            padding: "0px 15px",
            marginTop: 50,
            fontFamily: "Quicksand, Cairo",
          }}
        >
          {language == "english" ? "Login with" : "تسجيل الدخول بواسطة"}{" "}
        </h2>

        <List
          disablePadding
          dense
          component="nav"
          aria-label="Nav"
          style={{ direction: language == "english" ? "ltr" : "rtl" }}
        >
          <Divider />

          {settings.enable_phone_login && (
            <PhoneAuth history={this.props.history} language={language} />
          )}
          <AppleAuth history={this.props.history} language={language} />
          {this.props.promise.src === "web" && (
            <GoogleAuth history={this.props.history} language={language} />
          )}
        </List>

        {!this.state.verify && (
          <ActionButton
            action={
              <>
                {!this.state.loading ? (
                  <span className="bold">
                    {this.state.mode === 0
                      ? this.t("Register")
                      : this.t("Login")}
                  </span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </>
            }
            onClick={() => this.submit()}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    cart_items: state.cart.cart,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    address: state.customers?.address,
    pages: state.staticPages.pages,
    store: state.store.store,
    email: state.customers?.customerContact?.email || "",
    promise: state.promise,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
